export default __webpack_public_path__ + "static/media/img-0040.afe79440.png";